/* jshint esversion: 6 */
import React from 'react';
import { useOutletContext } from 'react-router';

export default function ComponentWithContext(Component) {
    function ComponentWrapper(props) {
        let context = useOutletContext(),
            composedProps = {};

        composedProps = Object.assign({}, props, context);

        return (
            <Component
                {...composedProps}/>
        );
    }


    return ComponentWrapper;
}
